import cx from 'classnames';
import { Icon } from 'components/Icon';
import type { Props as IconProps } from 'components/Icon';
import { StartAdornment } from './StartAdornment';

type Props = {
  name: IconProps['name'];
  className?: string;
  iconClassName?: string;
};

export const IconStartAdornment = ({ name, iconClassName, className }: Props): JSX.Element => {
  return (
    <StartAdornment className={cx(className, 'ml-[-8px]')}>
      <Icon name={name} className={iconClassName} />
    </StartAdornment>
  );
};
